(() => {
  function initialize(scope) {
    scope.querySelectorAll('[data-order-tracker]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const tabs = [...root.querySelectorAll('[data-tracker-tab]')];
      function select(tab) {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        root.querySelectorAll('[data-tracker-panel]').forEach(panel => {
          panel.hidden = panel.dataset.trackerPanel !== tab.dataset.trackerTab;
        });
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const target = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[tabs.length - 1] : tabs[(index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(target);
          target.focus();
        });
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
